module.exports = __webpack_public_path__ + "img/img_services_consulting.74873223.jpg";